import {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { useProgress } from '@react-three/drei';
import gsap from 'gsap';

import { ControlContext } from 'provider/ControlProvider';
import ProgressBar from 'react-animated-progress';
import 'react-animated-progress/dist/index.css';
export default function Home() {
  const { progress, loaded } = useProgress();

  const { setControlStatus, setCart } = useContext(ControlContext);
  const [disableBtn, setDisableBtn] = useState(false);
  const [hideLogo, SetLogo] = useState(false);
  const content = useRef<HTMLDivElement>(null);
  const bg = useRef<HTMLDivElement>(null);
  const app = useRef<HTMLDivElement>(null);
  const glowWheel = useRef<HTMLImageElement>(null);
  const wheel = useRef<HTMLImageElement>(null);
  const openDoorAnimation = () => {
    gsap.to('.leftDoorAnim', {
      x: -120,
      duration: 2,
      ease: 'power1.out',
    });
    gsap.to('.rightDoorAnim', {
      x: 120,
      duration: 2,
      ease: 'power1.out',
    });
    gsap.to('.wheelAnim', {
      x: 140,
      duration: 2,
      ease: 'power1.out',
    });
    gsap.to('.ScreenPanelAnim', {
      delay: 2,
      opacity: 0,
      duration: 1,
      ease: 'power1.out',
      onComplete: () => {
        setControlStatus(true);
      },
    });
  };
  const rotateWheelAnimation = () => {
    gsap.fromTo(
      '.wheelAnim',
      { rotation: 0 },
      {
        rotation: 360,
        transformOrigin: '50% 50%',
        repeat: 2,
        duration: 0.8,
        ease: 'none',
        onComplete: () => {
          gsap.fromTo(
            '.wheelAnim',
            { rotation: 0 },
            {
              rotation: 360,
              transformOrigin: '50% 49%',
              duration: 2,
              ease: 'power1.out',
              onComplete: () => {
                openDoorAnimation();
              },
            }
          );
        },
      }
    );
  };

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to('.outlineLogo', {
        opacity: 1,
        ease: 'power1.out',
        duration: 1.5,
        onComplete: () => {
          gsap.to('.outlineLogo', {
            opacity: 0,
            ease: 'power1.out',
            duration: 0.6,
          });
        },
      });
      gsap.to('.originLogo', {
        delay: 1.5,
        opacity: 1,
        ease: 'power2.out',
        duration: 3,
      });
      gsap.to('.glowLogo', {
        delay: 4,
        repeat: -1,
        yoyo: true,
        opacity: 1,
        ease: 'power1.out',
        duration: 1,
      });
    }, app);

    return () => ctx.revert();
  }, []);

  const slideEffect = () => {
    const data = localStorage.getItem('Cart');
    if (!data || data !== null) {
      const tempData = JSON.parse(data as string);
      setCart(tempData === null ? [] : tempData);
    }
    gsap.to(content.current, {
      duration: 1,
      ease: 'power1.out',
      opacity: 0,
      onComplete: () => {
        gsap.to(bg.current, {
          duration: 1,
          ease: 'power1.out',
          opacity: 0,
          onComplete: () => {
            SetLogo(true);
          },
        });
      },
    });
  };
  useEffect(() => {
    if (progress === 100) slideEffect();
  }, [progress, content, bg]);
  return (
    <div className='bg-black'>
      <div className='w-screen h-screen ios absolute z-50 flex items-center justify-center select-none ScreenPanelAnim'>
        <img
          src='assets/screenbg.png'
          className='object-cover fixed top-0 w-full h-full'
        />
        <img
          src='assets/rightDoor.png'
          className='object-cover fixed top-0 w-full h-full rightDoorAnim'
        />
        <img
          src='assets/leftDoor.png'
          className='object-cover fixed top-0 w-full h-full leftDoorAnim'
        />

        <img
          ref={wheel}
          src='assets/wheelofdoor.png'
          className='object-cover fixed top-1/2 translate-x-5 translate-y-6 wheelAnim '
        />
        <img
          ref={glowWheel}
          src='assets/glowwheelofdoor.png'
          className='object-cover fixed top-1/2 translate-x-5 translate-y-6 opacity-0 hover:opacity-100 transition-opacity duration-700 wheelAnim glowAnim '
          onClick={() => {
            if (!disableBtn) {
              setDisableBtn(true);
              rotateWheelAnimation();
            }
          }}
        />
        <img
          src='assets/screen.png'
          className='object-cover fixed top-0 w-full h-full pointer-events-none'
        />
        <button
          className='text-white absolute bottom-24 right-24 p-7 shadow-md drop-shadow-md hover:text-blue-900 duration-700'
          onClick={() => {
            if (!disableBtn) {
              setDisableBtn(true);
              rotateWheelAnimation();
            }
          }}
        >
          <p className='text-5xl underline '>Explore</p>
          <p className='text-2xl'>Spore s Journey</p>
        </button>
        {!hideLogo && (
          <div
            ref={bg}
            className='fixed w-full h-full'
            style={{ backgroundColor: '#18171C' }}
          >
            <div className=' p-5 md:p-10 h-screen ios w-screen flex justify-center items-center text-center'>
              <div
                ref={content}
                className='relative -translate-y-0 md:-translate-y-20 flex flex-col justify-center items-center space-y-5 text-secondaryColor '
              >
                <div ref={app}>
                  <img
                    className='absolute w-76 h-auto -top-40 left-0 border-none outlineLogo opacity-0'
                    src='/assets/outline.png'
                    alt='Spore&aposs Journey'
                  />
                  <img
                    className='absolute w-76 h-auto -top-40 left-0 border-none opacity-0 originLogo'
                    src='/assets/origin.png'
                    alt='Spore&aposs Journey'
                  />
                  <img
                    className='absolute w-76 h-auto -top-40 left-0 border-none opacity-0 glowLogo'
                    src='/assets/glow.png'
                    alt='Spore&aposs Journey'
                  />
                </div>
                <p className='font-bold text-lg mt-9 px-12 py-6 opacity-0'>
                  Please wait for a minute...
                </p>
                <h1 className='text-4xl'>Spore`s Journey</h1>
                <p className='text-lg mt-9'>Please wait for a minute...</p>
                <ProgressBar
                  value={progress}
                  color='#7E4E33'
                  style={{ marginTop: 15, height: 3 }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
